import {useEffect, useState} from 'react';
import {autorun, reaction} from 'mobx';
import {Col, Row} from 'antd';
import useCommon from '@utils/hooks/common';
import styles from './styles';
import PlayerIcon from '@components/PlayerIcon';
import PlayerAvatar from '@components/PlayerAvatar';
import router from 'next/router';
import useRequest from '@utils/hooks/useRequestCustom';
import authApi from '@utils/api/auth.api';
import {AxiosError} from 'axios';
import {Skeleton} from 'antd-mobile';
import {DEFAULT_COUNTRY_CODE} from '@components/CountrySelector';

const UserProfile = () => {
  const {classes, t, user, language} = useCommon({
    withTranslation: ['menu'],
    withStyles: styles,
    observers: ['language', 'user'],
  });

  const [iconUrl, setIconUrl] = useState<string>(null);
  const [userName, setUserName] = useState<string>('');
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [registrationType, setRegistrationType] = useState<'EMAIL' | 'METAMASK' | 'WALLET'>(
    'EMAIL'
  );
  const [address, setAddress] = useState<string>('');

  const {runAsync: runDepositAddress, loading} = useRequest(authApi.depositAddress, {
    manual: true,
    onSuccess: (data: any) => {
      setAddress(data?.data?.walletAddress);
    },
  });

  const checkVerification = async () => {
    const {playerThirdPartyInfo} = user || {};

    if (playerThirdPartyInfo?.isAccountVerified) {
      setIsVerified(true);
    }
    if (playerThirdPartyInfo?.registrationType) {
      setRegistrationType(
        playerThirdPartyInfo.registrationType.toUpperCase() as 'EMAIL' | 'METAMASK' | 'WALLET'
      );
    }
  };

  useEffect(() => {
    checkVerification();
    if (!user?.isThirdPartyGateway()) {
      runDepositAddress();
    }
  }, [user]);

  autorun(
    () => {
      if (user?.playerIconUrl !== iconUrl) {
        setIconUrl(user?.playerIconUrl);
      }
    },
    {delay: 10}
  );

  autorun(
    () => {
      // console.log('user displayName', user?.playerInfo?.displayName);
      if (user?.playerInfo?.displayName !== userName) {
        setUserName(user?.playerInfo?.displayName);
      }
    },
    {delay: 10}
  );

  // const defaultCountry = user?.playerInfo?.country || DEFAULT_COUNTRY;

  const renderAddressInfo = () => {
    if (loading) return <Skeleton animated className={classes.skeleton} />;

    if (isVerified) {
      const imgSrc =
        registrationType === 'EMAIL'
          ? '/images-mobile/header-mobile/header-game-logo_v2.webp'
          : '/images-mobile/LoginSelectButton/wallet-connect.svg';

      return (
        <div className={classes.addressArea}>
          <img src={imgSrc} className={classes.addressImg} alt="Address Icon" />
          <span className={classes.addressText}>{address}</span>
        </div>
      );
    }

    return <div className={classes.onlineStatus}>&bull; {t('online')}</div>;
  };

  const {countryCode} = user?.playerInfo || {};
  // console.log('UserProfile ~ countryCode:', countryCode);

  return (
    <Row className={classes.userProfile} gutter={8}>
      <Col
        className={classes.playerAvatarSection}
        span={7}
        onClick={() => {
          router.push('/user-profile');
        }}
      >
        <div className={classes.playerIconContainer}>
          <PlayerAvatar icon={iconUrl} iconWidthPx={80} />
          {countryCode && (
            <img
              src={`/images-mobile/country/${countryCode || DEFAULT_COUNTRY_CODE}.webp`}
              alt="country"
              className={classes.countryIcon}
            />
          )}
        </div>
      </Col>
      <Col span={17}>
        <section className={classes.userStatusContainer}>
          <div className={classes.userName}>{userName}</div>
          {renderAddressInfo()}
        </section>
      </Col>
    </Row>
  );
};

export default UserProfile;
